// extracted by mini-css-extract-plugin
module.exports = {"PlaceholderContainer":"styles_PlaceholderContainer__2fyxF","color-change":"styles_color-change__2ZluR"};